<template>
  <div>
    <div class="row myrow content-mb-42_" v-if="$parent.$parent.rerender">
      <div class="col-xs-12 mycol">
        <table
          class="c-indicator content-mb-18 table-indicators-min-cell"
          style="width: auto;"
        >
          <thead>
          <tr class="head-financlial-block">
            <th class="tab-wid-474">Наименование показателя</th>
            <th
              class="tab-wid-85 th-tc"
              v-for="item in targetYears"
              v-bind:value="item"
              v-bind:key="item"
              v-text="item"
            ></th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="indicator in project.FINANCIAL_INDICATORS.INDICATORS_ID"
            v-bind:value="indicator.ID"
            v-bind:key="indicator.ID"
            class="financlial"
            :class="
                indicator.IS_PROFITABILITY == 1 ||
                indicator.IS_AVERAGE_VALUE == 1
                  ? 'financlial-block'
                  : ''
              "
          >
            <td>{{ getName(indicator) }}</td>
            <td
              v-for="(item, key) in project.FINANCIAL_INDICATORS.items[
                  indicator.ID
                ]"
            >
              <template v-if="indicator.IS_AVERAGE_VALUE == 1">
                <input
                  v-if="
                      item.UF_INDICATORS_YEAR ==
                        project.FINANCIAL_INDICATORS.yearStart
                    "
                  v-bind:key="item.UF_FINANCIAL_INDICATORS_ID"
                  type="text"
                  class="i-main-style"
                  v-model="item.UF_INDICATORS_VALUE"
                  :disabled="true"
                />
              </template>

              <input
                v-else-if="
                    indicator.IS_PROFIT == 1 || indicator.IS_PROFITABILITY == 1
                  "
                v-bind:key="item.UF_FINANCIAL_INDICATORS_ID"
                type="text"
                class="i-main-style"
                v-model="item.UF_INDICATORS_VALUE"
                :disabled="true"
              />

              <vue-numeric
                v-else
                separator="space"
                v-bind:key="item.UF_FINANCIAL_INDICATORS_ID"
                type="text"
                class="i-main-style"
                v-model="item.UF_INDICATORS_VALUE"
                v-on:change.native="changeValue(item, key, indicator)"
                :disabled="
                    indicator.IS_SYSTEM_CALCULATE == 1 ||
                      $parent.$parent.projectDisabled
                  "
              />
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      class="row myrow content-mb-42_"
      v-if="$parent.$parent.rerender && isViewSpecialCompanyProjectSelect"
    >
      <div
        class="col-xs-12 mycol content-mb-14"
        v-bind:class="{
          'has-error': $parent.$parent.checkErrorField(
            'PROJECTS',
            'LOGIC',
            'UF_IS_COMPANY_SPECIAL_CREATED'
          )
        }"
      >
        <p class="content-s-2-label">
          <label
          >Является ли заявитель специально созданной под реализацию проекта
            компанией?</label
          >
        </p>
        <select
          v-model="$parent.project.UF_IS_COMPANY_SPECIAL_CREATED"
          class="sel-dropdown i-main-style i-wid-13"
          @change="changeIsCompany"
          :disabled="$parent.$parent.projectDisabled"
        >
          <option></option>
          <option :value="1">Да</option>
          <option :value="2">Нет</option>
        </select>
        <div class="error-text">
          {{
            $parent.$parent.checkErrorText(
              "PROJECTS",
              "LOGIC",
              "UF_IS_COMPANY_SPECIAL_CREATED"
            )
          }}
        </div>
      </div>
    </div>
    <div
      class="row myrow content-mb-42_"
      v-if="
        $parent.$parent.rerender &&
          isViewReestrOPKSelect &&
          project.UF_IS_COMPANY_SPECIAL_CREATED != ''
      "
    >
      <div
        class="col-xs-12 mycol content-mb-14"
        v-bind:class="{
          'has-error': $parent.$parent.checkErrorField(
            'PROJECTS',
            'LOGIC',
            'UF_IS_REESTR_OPK_INCLUDE'
          )
        }"
      >
        <p class="content-s-2-label">
          <label
            >Включен ли заявитель в Сводный реестр организаций
            оборонно-промышленного комплекса или является дочерним обществом
            таких организаций?</label
          >
        </p>

        <select
          v-model="project.UF_IS_REESTR_OPK_INCLUDE"
          class="sel-dropdown i-main-style i-wid-13"
          :disabled="$parent.$parent.projectDisabled"
        >
          <option></option>
          <option :value="1">Да</option>
          <option :value="0">Нет</option>
        </select>
        <div class="error-text">
          {{
            $parent.$parent.checkErrorText(
              "PROJECTS",
              "LOGIC",
              "UF_IS_REESTR_OPK_INCLUDE"
            )
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import Vue from "vue";
import { mapGetters } from "vuex";
import { FETCH_DIRECTORIES } from "@/store/actions.type";
import dividendsIndicator from "@/components/project/form/partial/DividendsIndicator.vue";

export default {
  name: "FinancialIndicator",
  components: { dividendsIndicator },
  data() {
    return {
      isViewSpecialCompanyProjectSelect: false,
      isViewReestrOPKSelect: false,
      idProfit: 0,
      idAverage: 0,
      idProfitability: 0,
      idVurychka: 0,
      isAllNull: true
    };
  },
  methods: {
    isNumber: function(evt, indicator, val) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;

      if (indicator.IS_PROCENT === 0 && charCode === 46) {
        evt.preventDefault();
        return false;
      }
      if (
        indicator.IS_PROCENT === 1 &&
        charCode === 46 &&
        typeof val.indexOf !== "undefined" &&
        val.indexOf(".") !== -1
      ) {
        evt.preventDefault();
        return false;
      }
      if (indicator.IS_PROCENT === 1 && charCode === 46) {
        return true;
      }
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    changeValue(item, key, indicator) {
      if (indicator.IS_USER_ADD == 1) {
        if (this.idProfit == 0) {
          for (let key2 in this.project.FINANCIAL_INDICATORS.INDICATORS_ID) {
            if (
              this.project.FINANCIAL_INDICATORS.INDICATORS_ID[key2][
                "IS_PROFIT"
              ] == 1
            ) {
              this.idProfit = parseInt(key2);
            }
            if (
              this.project.FINANCIAL_INDICATORS.INDICATORS_ID[key2][
                "IS_AVERAGE_VALUE"
              ] == 1
            ) {
              this.idAverage = parseInt(key2);
            }
            if (
              this.project.FINANCIAL_INDICATORS.INDICATORS_ID[key2][
                "IS_PROFITABILITY"
              ] == 1
            ) {
              this.idProfitability = parseInt(key2);
            }
            if (
              this.project.FINANCIAL_INDICATORS.INDICATORS_ID[key2]["CODE"] ==
              "revenue"
            ) {
              this.idVurychka = parseInt(key2);
            }
          }
        }

        //#48146
        //Прибыль / убыток от продаж = Выручка - Себестоимость - управленческие расходы - коммерческие расходы
        //idProfit
        //Рентабельность = Прибыль/убыток от продаж / ( Себестоимость + Управленческие расходы+Коммерческие расходы ) * 100%.
        // ( Если значение рентабельности получается отрицательным, то в ячейке отображаем 0 для среднеарифметического)
        //idProfitability

        let profitNew = 0;
        let profitabilitySummNew = 0; //рентабельность
        for (let keyInikator in this.project.FINANCIAL_INDICATORS.items) {
          for (let keyValue in this.project.FINANCIAL_INDICATORS.items[
            keyInikator
            ]) {
            if (keyValue == key) {
              let tempIndicator = parseInt(
                this.project.FINANCIAL_INDICATORS.items[keyInikator][keyValue][
                  "UF_FINANCIAL_INDICATORS_ID"
                  ]
              );
              if (tempIndicator == this.idVurychka) {
                profitNew += this.project.FINANCIAL_INDICATORS.items[
                  keyInikator
                  ][keyValue]["UF_INDICATORS_VALUE"];
              } else if (
                tempIndicator !== this.idProfit &&
                tempIndicator !== this.idAverage &&
                tempIndicator !== this.idProfitability
              ) {
                profitNew -= parseInt(
                  this.project.FINANCIAL_INDICATORS.items[keyInikator][
                    keyValue
                    ]["UF_INDICATORS_VALUE"]
                );
                profitabilitySummNew += parseInt(
                  this.project.FINANCIAL_INDICATORS.items[keyInikator][
                    keyValue
                    ]["UF_INDICATORS_VALUE"]
                );
              }
            }
          }
        }

        this.project.FINANCIAL_INDICATORS.items[this.idProfit][key][
          "UF_INDICATORS_VALUE"
          ] = profitNew;

        let profabilityNew =
          profitabilitySummNew > 0
            ? (profitNew / profitabilitySummNew) * 100
            : 0;
        if (parseInt(profabilityNew) == parseFloat(profabilityNew)) {
          profabilityNew = parseInt(profabilityNew);
        } else {
          profabilityNew = profabilityNew.toFixed(2);
        }
        this.project.FINANCIAL_INDICATORS.items[this.idProfitability][key][
          "UF_INDICATORS_VALUE"
          ] = profabilityNew < 0 ? 0 : profabilityNew;

        //Среднее значение рентабельности за четыре года = среднеарифметическое значение рентабельности за четыре года
        let summProfibilityAll = 0;
        for (let keyValue in this.project.FINANCIAL_INDICATORS.items[
          this.idProfitability
          ]) {
          summProfibilityAll =
            summProfibilityAll +
            parseFloat(
              this.project.FINANCIAL_INDICATORS.items[this.idProfitability][
                keyValue
                ]["UF_INDICATORS_VALUE"]
            );
        }

        let averageNew =
          summProfibilityAll > 0
            ? summProfibilityAll /
            this.project.FINANCIAL_INDICATORS.items[this.idProfitability]
              .length
            : 0;

        /*if (parseInt(profabilityNew) == parseFloat(profabilityNew)) {
          averageNew = parseInt(averageNew);
        } else {
          averageNew = Math.round(averageNew, 1);
        }*/

        this.project.FINANCIAL_INDICATORS.items[this.idAverage][0][
          "UF_INDICATORS_VALUE"
          ] = averageNew < 0 ? 0 : averageNew.toFixed(2);
        this.getError();
      }
    },
    getError() {
      let isError2Year = false;
      for (let keyValue in this.project.FINANCIAL_INDICATORS.items[
        this.idProfitability
        ]) {
        let year = this.project.FINANCIAL_INDICATORS.items[
          this.idProfitability
          ][keyValue]["UF_INDICATORS_YEAR"];
        if (
          year >= this.project.FINANCIAL_INDICATORS.yearEnd - 1 &&
          year <= this.project.FINANCIAL_INDICATORS.yearEnd
        ) {
          if (
            parseFloat(
              this.project.FINANCIAL_INDICATORS.items[this.idProfitability][
                keyValue
                ]["UF_INDICATORS_VALUE"]
            ) < 2
          ) {
            //доп проверка
            isError2Year = true;
          }
        }
      }

      if (isError2Year) {
        if (
          parseFloat(
            this.project.FINANCIAL_INDICATORS.items[this.idAverage][0][
              "UF_INDICATORS_VALUE"
              ]
          ) >= 2
        ) {
          this.isViewSpecialCompanyProjectSelect =
            this.project.ORG_INFO.IS_ERROR_DATE_REGISTER == 1 ? true : false;
          this.isViewReestrOPKSelect = false;
          //this.project.UF_IS_COMPANY_SPECIAL_CREATED = "";
          this.project.UF_IS_REESTR_OPK_INCLUDE = 0;
        } else {
          this.isViewSpecialCompanyProjectSelect = true;

          if (this.project.UF_IS_COMPANY_SPECIAL_CREATED == 1) {
            this.isViewReestrOPKSelect = false;
            this.project.UF_IS_REESTR_OPK_INCLUDE = 0;
          } else if (this.project.UF_IS_COMPANY_SPECIAL_CREATED == 2) {
            this.isViewReestrOPKSelect = true;
          }
        }
      } else {
        //корректировка условия появления #50344
        this.isViewSpecialCompanyProjectSelect =
          this.project.ORG_INFO.IS_ERROR_DATE_REGISTER == 1 ? true : false;
        this.isViewReestrOPKSelect = false;
        //this.project.UF_IS_COMPANY_SPECIAL_CREATED = "";
        this.project.UF_IS_REESTR_OPK_INCLUDE = 0;
      }
    },
    changeIsCompany() {
      if (this.project.UF_IS_COMPANY_SPECIAL_CREATED == 2) {
        this.isViewReestrOPKSelect = true;
        this.project.UF_IS_REESTR_OPK_INCLUDE = "";
      } else {
        this.isViewReestrOPKSelect = false;
      }
    },
    in_array(idFind, a) {
      return a.filter(function(item) {
        return item == idFind;
      }).length
        ? true
        : false;
    },
    getName(indicator) {
      if (
        this.project.UF_SETTING &&
        this.project.UF_SETTING.IS_NEW_NAME_FINACIAL_INDICATORS == 1 &&
        this.in_array(
          indicator.ID,
          this.project.UF_SETTING.ID_NEW_NAME_FINACIAL_INDICATORS_ARR
        ) &&
        indicator.NEW_NAME !== ""
      ) {
        return indicator.NEW_NAME;
      } else {
        return indicator.NAME;
      }
    },
  },
  computed: {
    ...mapGetters(["directory", "project"]),
    targetYears() {
      let years = [];
      for (
        let i = this.project.FINANCIAL_INDICATORS.yearStart;
        i <= this.project.FINANCIAL_INDICATORS.yearEnd;
        i++
      ) {
        years.push(i);
      }
      return years;
    }
  },
  async created() {
    await this.$store.dispatch(FETCH_DIRECTORIES, [
      "sp_financial_indicator_org"
    ]);

    if (this.project.FINANCIAL_INDICATORS.INDICATORS_ID) {
      for (let key2 in this.project.FINANCIAL_INDICATORS.INDICATORS_ID) {
        if (
          this.project.FINANCIAL_INDICATORS.INDICATORS_ID[key2]["IS_PROFIT"] ==
          1
        ) {
          this.idProfit = parseInt(key2);
        }
        if (
          this.project.FINANCIAL_INDICATORS.INDICATORS_ID[key2][
            "IS_AVERAGE_VALUE"
            ] == 1
        ) {
          this.idAverage = parseInt(key2);
        }
        if (
          this.project.FINANCIAL_INDICATORS.INDICATORS_ID[key2][
            "IS_PROFITABILITY"
            ] == 1
        ) {
          this.idProfitability = parseInt(key2);
        }
        if (
          this.project.FINANCIAL_INDICATORS.INDICATORS_ID[key2]["CODE"] ==
          "revenue"
        ) {
          this.idVurychka = parseInt(key2);
        }
      }
      this.getError();

      for (let keyInikator in this.project.FINANCIAL_INDICATORS.items) {
        for (let keyValue in this.project.FINANCIAL_INDICATORS.items[
          keyInikator
          ]) {
          if (
            this.project.FINANCIAL_INDICATORS.items[keyInikator][keyValue][
              "UF_INDICATORS_VALUE"
              ] > 0
          ) {
            this.isAllNull = false;
          }
        }
      }

      if (this.isAllNull) {
        // this.isViewSpecialCompanyProjectSelect =
        //   this.project.ORG_INFO.IS_ERROR_DATE_REGISTER == 1 ? true : false;
      } else {
        // this.changeValue(this.project.FINANCIAL_INDICATORS.items[this.idVurychka][0], 0, this.project.FINANCIAL_INDICATORS.INDICATORS_ID[this.idVurychka]) ;
      }
    }
  }
};
</script>

<style scoped></style>
